import React, { Component } from 'react';
import { Row, Col, MenuItem } from 'react-bootstrap';
import { FieldArray } from 'redux-form';
import FormSectionHeading from 'components/atoms/form/FormSectionHeading';
import DropdownButton from 'components/atoms/buttons/DropdownButton';
import WorkOrder from './WorkOrder';

class WorkOrderList extends Component {
    constructor(props) {
        super(props);
        // We have to track this arbitrary state to ensure the 'key' given to every work order
        // render is unique so that we always ensure that the DOM updates the way we expect it to.
        this.state = {
            nextWorkOrderKey: 100000000
        };
        this.workOrderTopRef = React.createRef();
        this.createNewWorkOrder = this.createNewWorkOrder.bind(this);
        this.cloneExistingWorkOrder = this.cloneExistingWorkOrder.bind(this);
        this.renderWorkOrders = this.renderWorkOrders.bind(this);
    }

    createNewWorkOrder(adminPlatform) {
        // fields.unshift({ adminPlatform, new: true, key: this.state.nextWorkOrderKey });
        this.props.handleNewWorkOrder({ adminPlatform, new: true, key: this.state.nextWorkOrderKey });
        this.setState({
            nextWorkOrderKey: this.state.nextWorkOrderKey + 1
        });
    }

    cloneExistingWorkOrder(originalWorkOrder) {
        window.scrollTo({
            top: this.workOrderTopRef.current.offsetTop + 300,
            behavior: 'smooth'
        });
        const baseWorkOrder = { adminPlatform: 'salesforce', new: true, key: this.state.nextWorkOrderKey, salesforceId: originalWorkOrder.salesforceId ? originalWorkOrder.salesforceId : '' };
        this.props.handleCloneExistingWorkOrder({ baseWorkOrder, originalWorkOrder });
        this.setState({
            nextWorkOrderKey: this.state.nextWorkOrderKey + 1
        });
    }

    renderWorkOrders({ fields, meta: { error, submitFailed } }) {
        const result = [
            <Row key="control">
                <Col xs={12}>
                    {submitFailed && error && <span>{error}</span>}
                    <DropdownButton title="ADD NEW WORK ORDER" id="dropdown-add-new-workorder">
                        <MenuItem eventKey="ccms" onClick={() => this.createNewWorkOrder('ccms')}>CCMS</MenuItem>
                        <MenuItem eventKey="salesforce" onClick={() => this.createNewWorkOrder('salesforce')}>Campaign Engine</MenuItem>
                    </DropdownButton>
                </Col>
            </Row>
        ];

        const workOrderRenders = fields.map((fieldKey, index) => {
            const workOrder = fields.get(index);
            return (
                <WorkOrder
                    dispatch={this.props.dispatch}
                    formName={this.props.formName}
                    key={`${workOrder.adminPlatform}-${workOrder.id || workOrder.key}`}
                    workOrder={workOrder}
                    fieldKey={fieldKey}
                    defaultExpandChannels={workOrder.new}
                    handleOverrideRemoval={this.props.handleOverrideRemoval}
                    switchWorkOrderPlatforms={this.props.switchWorkOrderPlatforms}
                    handleDelete={() => fields.remove(index)}
                    handleClone={() => this.cloneExistingWorkOrder(workOrder)}
                />
            );
        });

        return result.concat(workOrderRenders);
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col xs={12}>
                        <FormSectionHeading ref={this.workOrderTopRef}>Work Orders</FormSectionHeading>
                        <p>
                            A work order tells the system which Salesforce Opportunity ID the
                            dashboard should report on. It also informs what dates, channels,
                            and platforms will be included.
                        </p>
                    </Col>

                </Row>
                <FieldArray name='workOrders' component={this.renderWorkOrders} />
                <hr />
            </React.Fragment>
        );
    }
}

export default WorkOrderList;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/WorkOrderList.js